export const ProviderLogo = {
  "pragmatic": require("../../../assets/img/catalog/fortuna45/pragmatic.png"),
  "evoplay": require("../../../assets/img/catalog/fortuna45/evoplay.png"),
  "egt_digital": require("../../../assets/img/catalog/fortuna45/egt.png"),
  "greentube": require("../../../assets/img/catalog/fortuna45/greentube.png"),
  "habanero": require("../../../assets/img/catalog/fortuna45/habanero.png"),
  "gaminator": require("../../../assets/img/catalog/fortuna45/gaminator.png"),
  "apollo_games": require("../../../assets/img/catalog/fortuna45/apollo_games.png"),
  "spribe": require("../../../assets/img/catalog/fortuna45/spribe.png"),
  "blueprint_gaming": require("../../../assets/img/catalog/fortuna45/blueprint_gaming.png"),
  "playson": require("../../../assets/img/catalog/fortuna45/playson.png"),
  "betsoft": require("../../../assets/img/catalog/fortuna45/betsoft.png"),
  "scientific_games": require("../../../assets/img/catalog/fortuna45/scientific_games.png"),
  "evolution": require("../../../assets/img/catalog/fortuna45/evolution_gaming.png"),
  "egt": require("../../../assets/img/catalog/fortuna45/egt.png"),
  "merkur": require("../../../assets/img/catalog/fortuna45/merkur.png"),
  "novomatic": require("../../../assets/img/catalog/fortuna45/novomatic.png"),
  "booongo": require("../../../assets/img/catalog/fortuna45/booongo.png"),
  "ezugi": require("../../../assets/img/catalog/fortuna45/ezugi.png"),
  "aviatrix": require("../../../assets/img/catalog/fortuna45/aviatrix.png"),
  "yeebet": require("../../../assets/img/catalog/fortuna45/yeebet.png"),
  "ailivecasino": require("../../../assets/img/catalog/fortuna45/ailivecasino.png"),
  "fatpanda": require("../../../assets/img/catalog/fortuna45/fatpanda.png"),
  "pgsoft": require("../../../assets/img/catalog/fortuna45/pgsoft.png"),
  "reelkingdom": require("../../../assets/img/catalog/fortuna45/reelkingdom.png"),
  "toptrendgaming": require("../../../assets/img/catalog/fortuna45/toptrendgaming.png"),
  "goldenrace": require("../../../assets/img/catalog/fortuna45/goldenrace.png"),
  "dreamgaming": require("../../../assets/img/catalog/fortuna45/dreamgaming.png"),
  "worldentertainment": require("../../../assets/img/catalog/fortuna45/worldentertainment.png"),
  "awc": require("../../../assets/img/catalog/fortuna45/awc.png"),
  "ct855(k0)": require("../../../assets/img/catalog/fortuna45/ct855.png"),
  "wmcasino": require("../../../assets/img/catalog/fortuna45/wmcasino.png"),
  "vivo": require("../../../assets/img/catalog/fortuna45/vivo.png"),
  "portomaso": require("../../../assets/img/catalog/fortuna45/portomaso.png"),
  "quickspin": require("../../../assets/img/catalog/fortuna45/quickspin.png"),
  "btg": require("../../../assets/img/catalog/fortuna45/btg.png"),
  "konami": require("../../../assets/img/catalog/fortuna45/konami.png"),
  "wmg": require("../../../assets/img/catalog/fortuna45/wmg.png"),
  "microgaming": require("../../../assets/img/catalog/fortuna45/microgaming.png"),
  "n2": require("../../../assets/img/catalog/fortuna45/n2.png"),
  "apollo": require("../../../assets/img/catalog/fortuna45/apollo.png"),
  "kajot": require("../../../assets/img/catalog/fortuna45/kajot.png"),
  "jetx": require("../../../assets/img/catalog/fortuna45/jetx.png"),
  "fachai": require("../../../assets/img/catalog/fortuna45/fachai.png"),
  "mrslotty": require("../../../assets/img/catalog/fortuna45/mrslotty.png"),
  "bigpot": require("../../../assets/img/catalog/fortuna45/bigpot.png"),
  "epicwin": require("../../../assets/img/catalog/fortuna45/epicwin.png"),
  "kagaming": require("../../../assets/img/catalog/fortuna45/kagaming.png"),
  "rich88": require("../../../assets/img/catalog/fortuna45/rich88.png"),
  "igt": require("../../../assets/img/catalog/fortuna45/igt.png"),
  "jili": require("../../../assets/img/catalog/fortuna45/jili.png"),
  "cq9": require("../../../assets/img/catalog/fortuna45/cq9.png"),
  "live22": require("../../../assets/img/catalog/fortuna45/live22.png"),
  "spadegaming": require("../../../assets/img/catalog/fortuna45/spadegaming.png"),
  "7777": require("../../../assets/img/catalog/fortuna45/7777Gaming.png"),
  "1x2gaming": require("../../../assets/img/catalog/fortuna45/1x2Gaming.png"),
  "3oaks": require("../../../assets/img/catalog/fortuna45/3Oaks_3.png"),
  "3oaksP": require("../../../assets/img/catalog/fortuna45/3Oaks_3.png"),
  "7-mojos-slots": require("../../../assets/img/catalog/fortuna45/7mojosGaming.png"),
  "airdice": require("../../../assets/img/catalog/fortuna45/AirDiceGaming.png"),
  "altente": require("../../../assets/img/catalog/fortuna45/AltenteGaming.png"),
  "amigogaming": require("../../../assets/img/catalog/fortuna45/AmigoGaming.png"),
  "amusnet": require("../../../assets/img/catalog/fortuna45/AmusnetGaming.png"),
  "apparat": require("../../../assets/img/catalog/fortuna45/ApparatGaming.png"),
  "armadillostudios": require("../../../assets/img/catalog/fortuna45/ArmadilloGaming.png"),
  "backseat": require("../../../assets/img/catalog/fortuna45/BackseatGaming.png"),
  "barbara-bang": require("../../../assets/img/catalog/fortuna45/BarbarabangGaming.png"),
  "betsoft-a": require("../../../assets/img/catalog/fortuna45/BetSoftGaming.png"),
  "bfgames": require("../../../assets/img/catalog/fortuna45/BFGamesGaming.png"),
  "bfgamesB": require("../../../assets/img/catalog/fortuna45/BFGamesGaming.png"),
  "bgaming": require("../../../assets/img/catalog/fortuna45/BGamingGaming.png"),
  "bgamingP": require("../../../assets/img/catalog/fortuna45/BGamingGaming.png"),
  "bigtimegaming-gh": require("../../../assets/img/catalog/fortuna45/BigTimeGaming.png"),
  "booming": require("../../../assets/img/catalog/fortuna45/BoomingGaming.png"),
  "boominggames": require("../../../assets/img/catalog/fortuna45/BoomingGaming.png"),
  "bullshark": require("../../../assets/img/catalog/fortuna45/BullsharkGaming.png"),
  "bwgaming": require("../../../assets/img/catalog/fortuna45/BWGaming.png"),
  "caletagaming": require("../../../assets/img/catalog/fortuna45/CaletaGaming.png"),
  "clawbuster": require("../../../assets/img/catalog/fortuna45/ClawbusterGaming.png"),
  "ctinteractive": require("../../../assets/img/catalog/fortuna45/CT_InteractiveGaming.png"),
  "dreamplay": require("../../../assets/img/catalog/fortuna45/DreamPlayGaming.png"),
  "eagaming": require("../../../assets/img/catalog/fortuna45/EAGaming.png"),
  "elagames-a": require("../../../assets/img/catalog/fortuna45/ElaGamesGaming.png"),
  "endorphina": require("../../../assets/img/catalog/fortuna45/EndorphinaGaming.png"),
  "fazi": require("../../../assets/img/catalog/fortuna45/FaziGaming.png"),
  "fils": require("../../../assets/img/catalog/fortuna45/FilsGameGaming.png"),
  "flipluck": require("../../../assets/img/catalog/fortuna45/FlipLuckGaming.png"),
  "formulaspin": require("../../../assets/img/catalog/fortuna45/FormulaSpinGaming.png"),
  "galaxsys": require("../../../assets/img/catalog/fortuna45/GalaxsysGaming.png"),
  "gamebeat": require("../../../assets/img/catalog/fortuna45/GameBeatGaming.png"),
  "gamzix": require("../../../assets/img/catalog/fortuna45/GamixGaming.png"),
  "hacksaw": require("../../../assets/img/catalog/fortuna45/HacksawGaming.png"),
  "iconic21-slots": require("../../../assets/img/catalog/fortuna45/Iconic21Gaming.png"),
  "iconix": require("../../../assets/img/catalog/fortuna45/IconixViatorGaming.png"),
  "irondog": require("../../../assets/img/catalog/fortuna45/IronDogGaming.png"),
  "irondogP": require("../../../assets/img/catalog/fortuna45/IronDogGaming.png"),
  "irondogPP": require("../../../assets/img/catalog/fortuna45/IronDogGaming.png"),
  "jvl": require("../../../assets/img/catalog/fortuna45/JVLGaming.png"),
  "macaw": require("../../../assets/img/catalog/fortuna45/MacawGaming.png"),
  "mancala": require("../../../assets/img/catalog/fortuna45/MancalaGaming.png"),
  "micro-gaming": require("../../../assets/img/catalog/fortuna45/microgaming.png"),
  "netent": require("../../../assets/img/catalog/fortuna45/NetEntGaming.png"),
  "netent-gh": require("../../../assets/img/catalog/fortuna45/NetEntGaming.png"),
  "netgame": require("../../../assets/img/catalog/fortuna45/NetgameGaming.png"),
  "netgameP": require("../../../assets/img/catalog/fortuna45/NetgameGaming.png"),
  "nolimitcity-gh": require("../../../assets/img/catalog/fortuna45/NolimitCityGaming.png"),
  "novo-matic": require("../../../assets/img/catalog/fortuna45/NovomaticGaming.png"),
  "onegame": require("../../../assets/img/catalog/fortuna45/OneGame.png"),
  "onetouch": require("../../../assets/img/catalog/fortuna45/OnetouchGaming.png"),
  "pascalgaming": require("../../../assets/img/catalog/fortuna45/PascalGaming.png"),
  "pateplay": require("../../../assets/img/catalog/fortuna45/PatePlayGaming.png"),
  "phoenix7": require("../../../assets/img/catalog/fortuna45/Phoenix7_w.png"),
  "pixmove-games": require("../../../assets/img/catalog/fortuna45/PixmoveGaming.png"),
  "platingaming": require("../../../assets/img/catalog/fortuna45/PlatinGaming_w.png"),
  "platipus": require("../../../assets/img/catalog/fortuna45/PlatipusGaming.png"),
  "play-son": require("../../../assets/img/catalog/fortuna45/playson.png"),
  "play-sonP": require("../../../assets/img/catalog/fortuna45/PlaysonGaming.png"),
  "popiplay": require("../../../assets/img/catalog/fortuna45/PopiplayGaming.png"),
  "popok": require("../../../assets/img/catalog/fortuna45/PopOkGaming.png"),
  "prospectgaming": require("../../../assets/img/catalog/fortuna45/ProspectGames.png"),
  "redrake": require("../../../assets/img/catalog/fortuna45/RedRakeGaming.png"),
  "redstone": require("../../../assets/img/catalog/fortuna45/RedstoneGaming.png"),
  "redtiger-gh": require("../../../assets/img/catalog/fortuna45/RedTigerGaming.png"),
  "retrogames": require("../../../assets/img/catalog/fortuna45/RetroGaming.png"),
  "rubyplay": require("../../../assets/img/catalog/fortuna45/RubyPlayGaming.png"),
  "skywind": require("../../../assets/img/catalog/fortuna45/SkyWindgroupGaming.png"),
  "smartsoft": require("../../../assets/img/catalog/fortuna45/Smartsoft_Gaming_bw.png"),
  "spearhead": require("../../../assets/img/catalog/fortuna45/SpearheadGaming.png"),
  "spearheadP": require("../../../assets/img/catalog/fortuna45/Spearhead_bw.png"),
  "spinomenal": require("../../../assets/img/catalog/fortuna45/Spinomenal_w.png"),
  "tada": require("../../../assets/img/catalog/fortuna45/TaDaGaming.png"),
  "tiptop": require("../../../assets/img/catalog/fortuna45/TipTopGaming.png"),
  "turbo-games": require("../../../assets/img/catalog/fortuna45/TurboGamesGaming.png"),
  "voltentertainment": require("../../../assets/img/catalog/fortuna45/VoltEntertainment.png"),
  "wazdan-a": require("../../../assets/img/catalog/fortuna45/WazdanGaming.png"),
  "yggdrasil-a": require("../../../assets/img/catalog/fortuna45/YggdrasilGaming_bw.png"),
  "intouch-games": require("../../../assets/img/catalog/fortuna45/intouch-games.png"),
  "only-play": require("../../../assets/img/catalog/fortuna45/only-play.png"),
  "egtdigital": require("../../../assets/img/catalog/fortuna45/egtdigital.png"),
  "playstar": require("../../../assets/img/catalog/fortuna45/playstar.png"),
  "slotopia": require("../../../assets/img/catalog/fortuna45/slotopia.png"),
  "wowgaming": require("../../../assets/img/catalog/fortuna45/wowgaming.png"),
  "aviator": require("../../../assets/img/catalog/fortuna45/aviator.png"),
  "rocketman": require("../../../assets/img/catalog/fortuna45/rocketman.png"),
  "dreamtech": require("../../../assets/img/catalog/fortuna45/dreamtech.png"),
  "GASEA_Evoplay": require("../../../assets/img/catalog/fortuna45/evoplay.png"),
  "GASEA_Pragmatic_Play": require("../../../assets/img/catalog/fortuna45/pragmatic.png"),
  "GASEA_7Mojos": require("../../../assets/img/catalog/fortuna45/7mojosGaming.png"),
  "GASEA_Aviator_Studio": require("../../../assets/img/catalog/fortuna45/aviator.png"),
  "GASEA_Hacksaw": require("../../../assets/img/catalog/fortuna45/HacksawGaming.png"),
  "GASEA_Tada": require("../../../assets/img/catalog/fortuna45/TaDaGaming.png"),
  "GASEA_YeeBet": require("../../../assets/img/catalog/fortuna45/yeebet.png"),
  "GASEA_Spribe": require("../../../assets/img/catalog/fortuna45/spribe.png"),
  "GASEA_Bgaming": require("../../../assets/img/catalog/fortuna45/BGamingGaming.png"),
  "GASEA_Habanero": require("../../../assets/img/catalog/fortuna45/habanero.png"),
  "GASEA_Microgaming": require("../../../assets/img/catalog/fortuna45/microgaming.png"),
  "GASEA_Evolution_Live": require("../../../assets/img/catalog/fortuna45/evolution_gaming.png"),
  "GASEA_Spade_Gaming": require("../../../assets/img/catalog/fortuna45/spadegaming.png"),
  "GASEA_Iconic21": require("../../../assets/img/catalog/fortuna45/Iconic21Gaming.png"),
  "GASEA_Endorphina": require("../../../assets/img/catalog/fortuna45/EndorphinaGaming.png"),
  "GASEA_Gamzix": require("../../../assets/img/catalog/fortuna45/GamixGaming.png"),
  "GASEA_Fachai": require("../../../assets/img/catalog/fortuna45/fachai.png"),
  "GASEA_SmartSoft": require("../../../assets/img/catalog/fortuna45/Smartsoft_Gaming_bw.png"),
  "GASEA_Live22": require("../../../assets/img/catalog/fortuna45/live22.png"),
  "GASEA_Spinomenal": require("../../../assets/img/catalog/fortuna45/Spinomenal_w.png"),
  "GASEA_Booming": require("../../../assets/img/catalog/fortuna45/BoomingGaming.png"),
  "GASEA_EpicWin": require("../../../assets/img/catalog/fortuna45/epicwin.png"),
  "GASEA_Turbo_Games": require("../../../assets/img/catalog/fortuna45/TurboGamesGaming.png"),
  "GASEA_CQ9": require("../../../assets/img/catalog/fortuna45/cq9.png"),
  "GASEA_PG_Soft": require("../../../assets/img/catalog/fortuna45/pgsoft.png"),
  "GASEA_AA_Sexy": require("../../../assets/img/catalog/fortuna45/sexygaming.png"),
  "GASEA_Big_Time_Gaming": require("../../../assets/img/catalog/fortuna45/BigTimeGaming.png"),
  "GASEA_3Oaks": require("../../../assets/img/catalog/fortuna45/3Oaks_3.png"),
  "GASEA_Netent": require("../../../assets/img/catalog/fortuna45/NetEntGaming.png"),
  "GASEA_NoLimit_City": require("../../../assets/img/catalog/fortuna45/NolimitCityGaming.png"),
  "GASEA_Playson": require("../../../assets/img/catalog/fortuna45/PlaysonGaming.png"),
  "GASEA_Red_Tiger": require("../../../assets/img/catalog/fortuna45/RedTigerGaming.png"),
  "GASEA_Ruby_Play": require("../../../assets/img/catalog/fortuna45/RubyPlayGaming.png"),
  "GASEA_YellowBat": require("../../../assets/img/catalog/gasea/YellowBatGaming.png"),
  "GASEA_Vplus": require("../../../assets/img/catalog/gasea/vplus.png"),
  "GASEA_Thunderkick": require("../../../assets/img/catalog/gasea/GASEA_Thunderkick.png"),
  "GASEA_The_Better_Platform": require("../../../assets/img/catalog/gasea/The_Better_Platform.png"),
  "GASEA_Relax_Gaming": require("../../../assets/img/catalog/gasea/Relax_Gaming.png"),
  "GASEA_KingMidas": require("../../../assets/img/catalog/gasea/kingmidas.png"),
  "GASEA_JDB": require("../../../assets/img/catalog/gasea/JDB.png"),
  "GASEA_GTF": require("../../../assets/img/catalog/gasea/GTF.png"),
  "GASEA_PlayNGo": require("../../../assets/img/catalog/gasea/PlayNGo.png"),
  "GASEA_Lets_Go": require("../../../assets/img/catalog/gasea/Lets_Go.png"),
  "GASEA_DB_Slots": require("../../../assets/img/catalog/gasea/DB_Slots.png"),
  "GASEA_CP_Games": require("../../../assets/img/catalog/gasea/CP_Games.png"),
  "GASEA_CG": require("../../../assets/img/catalog/gasea/CG.png"),
  "GASEA_BNG": require("../../../assets/img/catalog/gasea/BNG.png"),
  "GASEA_AvatarUX": require("../../../assets/img/catalog/gasea/AvatarUX.png"),
  "GASEA_Alize_Slots": require("../../../assets/img/catalog/gasea/Alize_Slots.png"),
  "GASEA_AdvantPlay": require("../../../assets/img/catalog/gasea/AdvantPlay.png"),
  "GASEA_Crystal": require("../../../assets/img/catalog/gasea/Crystal.png"),
  "amatic": require("../../../assets/img/catalog/gasea/amatic.png"),
  "vivolive": require("../../../assets/img/catalog/fortuna45/vivo.png"),
  "yoriginal-games": require("../../../assets/img/catalog/gasea/yoriginal-games.png"),
  "in-out": require("../../../assets/img/catalog/gasea/in-out.png"),

  "NONAMEHERO_amatic": require("../../../assets/img/catalog/gasea/amatic.png"),
  "NONAMEHERO_amusnet": require("../../../assets/img/catalog/fortuna45/AmusnetGaming.png"),
  "NONAMEHERO_aristocrat": require("../../../assets/img/catalog/aristocrat.png"),
  "NONAMEHERO_blueprint": require("../../../assets/img/catalog/fortuna45/blueprint_gaming.png"),
  "NONAMEHERO_bomba": require("../../../assets/img/catalog/bomba.png"),
  "NONAMEHERO_egtdgtl": require("../../../assets/img/catalog/fortuna45/egtdigital.png"),
  "NONAMEHERO_isoftbet": require("../../../assets/img/catalog/isoftbet.png"),
  "NONAMEHERO_merkur": require("../../../assets/img/catalog/fortuna45/merkur.png"),
  "NONAMEHERO_netent": require("../../../assets/img/catalog/fortuna45/NetEntGaming.png"),
  "NONAMEHERO_noble": require("../../../assets/img/catalog/noble.png"),
  "NONAMEHERO_novomatic": require("../../../assets/img/catalog/fortuna45/novomatic.png"),
  "NONAMEHERO_playngo": require("../../../assets/img/catalog/play_n_go.png"),
  "NONAMEHERO_playtech": require("../../../assets/img/catalog/playtech.png"),
  "NONAMEHERO_pragmatic": require("../../../assets/img/catalog/pragmatic.png"),
  "NONAMEHERO_redtiger": require("../../../assets/img/catalog/fortuna45/RedTigerGaming.png"),
  "NONAMEHERO_yggdrasil": require("../../../assets/img/catalog/fortuna45/YggdrasilGaming_bw.png"),
};
